/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { createStore } from 'redux'
import { App }         from './reducers'


/*********************************************************************************
 2. Store
 *********************************************************************************/

export const AppStore = createStore(App);



// WEBPACK FOOTER //
// ./src/store/index.js